import React, { FC } from "react";
import { Group, Rect } from "react-konva";
import { SPESSORE_TELAIO_FINESTRA } from "../../../../../../../core/common_constants";
import { DatiPannello } from "../../../../../../../core/common_draw_types";
import { getStrokeColor, PlaceholderRect } from "../draw_utils";
import { IRect } from "konva/lib/types";
import { NullableString } from "../../../../../../../core/common_types";

export const Finestra: FC<{ panelData: DatiPannello, bbox: PlaceholderRect, spessoreTelaio: number, color: HTMLImageElement|undefined, colorCode?: NullableString, top?: number, onClick?: (placeholderData: PlaceholderRect) => void }> = (props) => {
    const {panelData, bbox, color, colorCode, spessoreTelaio, top, onClick} = props;
    const y = top ?? (panelData.bbox.height / 2) - (bbox.height / 2);

    let rectFrameExt: IRect = {
        x: bbox.x,
        y,
        width: bbox.width,
        height: bbox.height
    };

    let rectFrameInt: IRect = {
        x: bbox.x + spessoreTelaio,
        y: y + spessoreTelaio,
        width: bbox.width - (2*spessoreTelaio),
        height: bbox.height - (2*spessoreTelaio)
    };

    return (
        <Group onClick={() => onClick?.(bbox)} onTap={() => onClick?.(bbox)}>
            <Rect
                {...rectFrameExt}
                stroke={getStrokeColor(colorCode)} 
                strokeWidth={0.75}
                fillPatternImage={color}
            />
            <Rect
                {...rectFrameInt}
                stroke={getStrokeColor(colorCode)} 
                strokeWidth={0.75}
                fill={"lightblue"}
            />
        </Group>
    );
}